import colors from '../../constants/colors'
import { IBundle } from '../../types/booking'

export const getCardBackground = (currentBundle: string) => {
  if ((currentBundle as IBundle) === IBundle.free || currentBundle === 'FREE') return colors.bundleFree
  if ((currentBundle as IBundle) === IBundle.business || currentBundle === 'BUSINESS') return colors.bundleBusiness
  return colors.bundlePro
}
